import { defineComponent as _defineComponent } from 'vue'
import {useConfigurationStore} from "@/store/configuration.store";
import {onBeforeMount, onMounted, ref} from "vue";
import TopMenu from "@/components/commons/TopMenu.vue";


// const blockchain_version = process.env.VUE_APP_BLOCKCHAIN_VERSION;


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props, { expose: __expose }) {
  __expose();

const showVersion = ref<boolean>(false);
const versionDiv = ref<HTMLDivElement>();
const versionSpan = ref<HTMLDivElement>();

onBeforeMount(() => {
  console.log(useConfigurationStore().config.airdropPoolAddress);


});
onMounted(() => {
  const handleClickOutside = (event: MouseEvent) => {
    if (!versionDiv.value || !versionSpan.value) return;
    if (!versionDiv.value!.contains(event.target as Node) && !versionSpan.value!.contains(event.target as Node)) {
      if(showVersion.value==true)
        showVersion.value = false;
    } else if(versionSpan.value!.contains(event.target as Node)) {
      showVersion.value = !showVersion.value;
    }
  };
  document.addEventListener('click', handleClickOutside);
});


const __returned__ = { showVersion, versionDiv, versionSpan, TopMenu }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})